import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ConfigBranch from "../../../containers/modules/master/config-branch";

export default function ConfigBranchRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="config-branch"
      index
      element={
        <AccessControl
          name={"Config Branch List"}
          auth={authUser}
          component={() => <ConfigBranch authUser={authUser} />}
        />
      }
    />
  );
}
